<main fxLayout='column' fxLayoutAlign="center center">
  <div id="headerText">
    <p class="main-title">{{'customLotteryTitle' | translation}}</p>
    <p class="main-subtitle">{{'manageLottery' |translation}}</p>
  </div>

  <header fxLayout="column" fxLayoutAlign="center center">


    <section fxLayout="row" fxLayoutAlign="space-between center">

      <button id="btnAddQuestion" mat-raised-button color="accent" (click)="createLottery()">
        <mat-icon>add</mat-icon>
        {{'newLottery' |translation}}
      </button>

    </section>
  </header>

  <!-- **** LISTE DES Lottery **** -->
  <div *ngIf="listLottery != undefined" fxLayout="row" fxLayoutAlign="center flex-start"
       style="margin-top:20px; flex-wrap: wrap;" id="lotteryElementsWrapper">
    <mat-list>
      <mat-list-item *ngFor="let lottery of listLottery; let i = index" [ngClass]="{'selectedLottery': selectedLotteryIndex == i}">
        <div class="matItemContainer">

          <div class="listIconElement">

            <mat-icon mat-list-icon>
              question_answer
            </mat-icon>
          </div>
          <div class="listItemElement">
            <h4 mat-line>{{lottery.name}}</h4>

            <div  class="interactElement">
            <div class="activated" *ngIf="lottery.active">
              <mat-icon color="accent">check</mat-icon>
            </div>

            <button mat-icon-button [matMenuTriggerFor]="menuLotteryOptions">
              <mat-icon>
                more_vert
              </mat-icon>
            </button>
            </div>
            <mat-divider [inset]="true"></mat-divider>

          </div>
        </div>
        <mat-menu #menuLotteryOptions="matMenu">
          <button mat-menu-item (click)="getLotteryData(lottery, i)">{{'edit' | translation}}</button>
          <button mat-menu-item (click)="setActiveLottery(lottery, i)">{{'activate' | translation}}</button>
          <button mat-menu-item (click)="removeLottery(lottery, i)">{{'delete' |translation}}</button>
          <!-- <button mat-menu-item disabled (click)="renameLottery(lottery, i)">{{'rename' |translation}}</button>-->
        </mat-menu>

      </mat-list-item>
    </mat-list>
  </div>
  <div>
    <app-lottery *ngIf="selectedLotteryConfig" [fullConfig]="lotteryModuleData" [lotteryConfig]="selectedLotteryConfig.data" [moduleId]="lotteryModuleId" (configUpdate)="updateCurrentConfig($event)"></app-lottery>
  </div>
</main>
